import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputAssignmentComponent } from './components/input-assignment/input-assignment.component';
import { ProjectSpeakerSetupComponent } from './components/project-speaker-setup/project-speaker-setup.component';
import {ProjectSpeakerSetupService} from "@catmodels/project-speaker-setup/services/project-speaker-setup.service";
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DataTableModule} from "primeng/primeng";
import {UIBaseModule} from "@catui/ui-base.module";
import {UIFormModule} from "@catuiform/ui-form.module";
import {ExplorerModule} from "@catmodules/widgets/explorer/explorer.module";
import {ProjectSpeakerPortService} from "@catmodels/project-speaker-setup/services/project-speaker-port.service";
import { ModifyInputChannelsComponent } from './components/modify-input-channels/modify-input-channels.component';
import {AudioInputSignalService} from "@catmodels/project-speaker-setup/services/audio-input-signal.service";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    DataTableModule,
    UIBaseModule,
    UIFormModule,
    ReactiveFormsModule,
    ExplorerModule,
  ],
  entryComponents: [
    ModifyInputChannelsComponent,
  ],
  providers: [
    ProjectSpeakerSetupService,
    ProjectSpeakerPortService,
    AudioInputSignalService,
  ],
  declarations: [
    InputAssignmentComponent,
    ProjectSpeakerSetupComponent,
    ModifyInputChannelsComponent,
  ]
})
export class ProjectSpeakerSetupModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-speaker-setup/project-speaker-setup.module.ts